<div class="productDetailsVariants" [ngClass]="{'--selector': type === variantsType.DIMENSIONS}">
  <p>{{title(type) | translate}}</p>
  <ul *ngIf="type === variantsType.DIMENSIONS" class="productDetailsVariants__list" (mouseenter)="variants.length > 1 && (active = !active)" (mouseleave)="variants.length > 1 && (active = !active)" [ngClass]="{'--colors': type === variantsType.COLOUR, '--dimensions': type === variantsType.DIMENSIONS, '--active': active}">
    <li *ngFor="let variant of variants" [ngClass]="{'--selected': variant.selected}">
      <button (click)="changeVariant(variant.code)" [ngClass]="{'flaticon-down-arrow': type === variantsType.DIMENSIONS && variants.length > 1}">
         <span class="productDetailsVariants__dimension" *ngIf="type === variantsType.DIMENSIONS">
          <span *ngIf="variant.lensWidth" class="productDetailsVariants__lensWidth">{{variant.lensWidth}}mm</span>
          <span *ngIf="variant.noseSize" class="productDetailsVariants__noseSize">{{variant.noseSize}}mm</span>
          <span *ngIf="variant.templeLength" class="productDetailsVariants__templeLength">{{variant.templeLength}}mm</span>
          <span *ngIf="variant.lensHeight" class="productDetailsVariants__lensHeight">{{variant.lensHeight}}mm</span>
          <span *ngIf="variant.frameWidth" class="productDetailsVariants__frameWidth">{{variant.frameWidth}}mm</span>
        </span>
      </button>
    </li>
  </ul>

  <div *ngIf="type === variantsType.COLOUR" #sliderRef class="productDetailsVariants__list keen-slider keen-slider--vertical --colors" >
    <div *ngFor="let variant of variants" class="keen-slider__slide"  [ngClass]="{'--selected': variant.selected}">
      <button (click)="changeVariant(variant.code)" [ngClass]="{'flaticon-down-arrow': type === variantsType.DIMENSIONS && variants.length > 1}">
        <img *ngIf="type === variantsType.COLOUR" [ngSrc]="variant.image" [alt]="variant.code" width="77" height="42">
      </button>
    </div>
    <span 
    *ngIf="slider"
    [ngClass]=" 
      'arrow arrow--left ' + (slider.track.details.abs === slider.track.details.minIdx ? 'arrow--disabled' : '')
    "
    (click)="slider.prev()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 24"
        fill="#fff"
      >
        <path
          d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
        />
      </svg>
    </span>
    <span 
    *ngIf="slider"
    [ngClass]="
      'arrow arrow--right ' +
      (slider.track.details.abs === slider.track.details.maxIdx
        ? 'arrow--disabled'
        : '')
    "
    (click)="slider.next()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 24"
        fill="#fff"
      >
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      </svg>
  </span>
  </div>
</div>
